import { useUserProvider } from "./provider";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import "./index.css";
import { BsSendFill } from "react-icons/bs";
import { TbHeart, TbMailFilled } from "react-icons/tb";
import { useReportManager } from "../../wrappers/report";
import { BiLink } from "react-icons/bi";
import useCopy from "../../helpers/useCopy";
/**
 *
 * @param {import("@chakra-ui/react").ButtonProps & import("./props").UserProps} props
 * @returns
 */
const ShareButton = (props) => {
  const user = useUserProvider();
  const { copy } = useCopy();

  return (
    <Button
      variant={"secondary"}
      size="sm"
      leftIcon={<BiLink size={14} fontWeight={"bold"} />}
      onClick={() =>
        copy(`${window.location.origin}/user/${user.id}`, {
          title: "Link copied!",
        })
      }
      borderRadius={"full"}
      fontSize={"xs"}
      {...props}
    >
      Share
    </Button>
  );
};

export default ShareButton;
